
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[events]",
      function () {
        return require("private-next-pages/events/[events].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[events]"])
      });
    }
  